import { cn } from '@/lib/utils';

export type SimpleCardWidth = 'sm' | 'lg';

export interface SimpleCardProps extends React.PropsWithChildren {
  width: SimpleCardWidth;
  centered?: boolean;
}

export function SimpleCard({ centered = false, width, children }: SimpleCardProps): React.ReactElement {
  return (
    <div
      className={cn('flex w-full flex-1 justify-center p-4 sm:px-6 sm:py-8', centered ? 'items-center' : 'items-start')}
    >
      <div
        className={cn(
          'flex min-h-50 w-full flex-col gap-6 rounded-sm bg-card shadow',
          width === 'lg' ? 'max-w-6xl' : 'max-w-4xl',
        )}
      >
        {children}
      </div>
    </div>
  );
}
